/*
posibles tipos:
- multi
- selector
- listaNumeros
- fecha
- rangoFecha
 */

export default {
  filtrosFijos: [

  ],
  filtrosPorDefecto: [

  ],
  filtrosHabilitados: [
    { campo: 'nombre', tipo: 'texto' },
    { campo: 'tags', tipo: 'tags' },
    { campo: 'keywords', tipo: 'tags' },
    {
      campo: 'tipoObjeto',
      tipo: 'multi',
      opciones: [
        { nombre: 'Archivo', valor: '1' },
        { nombre: 'Carpeta', valor: '2' }
      ]
    },
    {
      campo: 'tipoExpiracion',
      tipo: 'multi',
      opciones: [
        { nombre: 'No vence', valor: '0' },
        { nombre: 'Vencimiento fijo', valor: '1' },
        { nombre: 'Vencimiento mensual', valor: '2' },
        { nombre: 'Vencimiento anual', valor: '3' }
      ]
    },
    {
      campo: 'estadoAprobacion',
      tipo: 'multi',
      opciones: [
        { nombre: 'No Aplica', valor: '0' },
        { nombre: 'En Aprobacion', valor: '1' },
        { nombre: 'Aprobado', valor: '2' },
        { nombre: 'Rechazado', valor: '3' }
      ]
    },
    {
      campo: 'estadoPublicacion',
      tipo: 'multi',
      opciones: [
        { nombre: 'Borrador', valor: '0' },
        { nombre: 'En Aprobacion', valor: '1' },
        { nombre: 'Publicado', valor: '2' },
      ]
    },
    { campo: 'fechaCreacion', tipo: 'rangoFecha' },
    { campo: 'fechaVencimiento', tipo: 'rangoFecha' },
    { campo: 'fechaModificacion', tipo: 'rangoFecha' },
    { campo: 'fechaPublicacion', tipo: 'rangoFecha' },
  ]
};
